// extracted by mini-css-extract-plugin
module.exports = {"controls":"VideoList_controls__UJ6Zt","videoWrapper":"VideoList_videoWrapper__1HHmJ","deleted":"VideoList_deleted__1yqhX","video":"VideoList_video__1UlQS"};